<template>
  <app-modal @close="dismissModal" :modal-mode="true">
    <template slot="body">
      <transition :name="transitionName" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
        <router-view></router-view>
      </transition>
    </template>
  </app-modal>
</template>

<style lang="scss" scoped>
.modal-container {
  overflow: hidden;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.2s;
  transition-property: height, opacity, transform;
  transition-timing-function: ease-in-out;
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

.slide-left-leave-active,
.slide-right-leave-active {
  position: absolute;
}
</style>

<script>
import AppModal from '@/components/AppModal'

export default {
  components: {
    AppModal
  },
  data () {
    return {
      transitionName: 'slide-left',
      prevHeight: 0
    }
  },
  beforeRouteEnter (to, from, next) {
    // no checkout if not able to place orders
    next(vm => {
      if (vm.widgetOptions.config.allow_orders) {
        next()
      } else {
        next('/')
      }
    })
  },
  methods: {
    dismissModal () {
      // replace /cart/* in current route
      const currentRoute = this.$router.currentRoute.fullPath
      const routeParts = currentRoute.split('/cart')
      if (!routeParts[0]) {
        this.$router.push('/')
      } else {
        this.$router.push(`${routeParts[0]}`)
      }
    },
    beforeLeave (element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter (element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      requestAnimationFrame(() => {
        element.style.height = height
      })
    },
    afterEnter (element) {
      element.style.height = 'auto'
    }
  },
  watch: {
    $route (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth >= fromDepth ? 'slide-left' : 'slide-right'
    }
  }
}
</script>
